module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zy_media"
  }, [_c('video', {
    attrs: {
      "poster": _vm.cover,
      "data-config": "{\"mediaTitle\": \"《疯狂动物城》--腾讯视频\"}"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video,
      "type": "video/mp4"
    }
  }), _vm._v("\n      您的浏览器不支持HTML5视频\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46832f6a"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/video/index.vue
// module id = 498
// module chunks = 4